import React, { useState, FC } from 'react';
import PartnersCardOptions from './partners-card-options';
import { PartnerType } from 'models/partner.model';
import EditPartnerDetails from 'pages/logistics/partners/edit-partner';
import DeletePartnerModal from 'pages/logistics/partners/partner-modals/delete-partner-modal';
import AddMananagersModal from 'components/logistics/add-managers';
import AddRidersModal from 'components/logistics/add-riders';
import RecordPayment from 'pages/logistics/partners/record-payment';
type PartnerCardFooterType = {
  partner: PartnerType;
  handleDeletePartner: (id: string) => void;
};
const PartnersCardFooter: FC<PartnerCardFooterType> = ({ partner, handleDeletePartner }) => {
  const [showEditPartnerModal, setShowEditPartnerModal] = useState(false);
  const [showDeletePartner, setShowDeletePartner] = useState(false);
  const [showRecordPayment, setShowRecordPayment] = useState(false);
  const [showAddRiders, setShowAddRiders] = useState(false);
  const [showAddManagers, setShowAddManagers] = useState(false);

  const closeDeletePartner = () => {
    setShowDeletePartner(!showDeletePartner);
  };

  const deletePartner = () => {
    setShowDeletePartner(!showDeletePartner);
  };
  const editPartnerDetails = () => {
    setShowEditPartnerModal(!showEditPartnerModal);
  };
  const recordPayment = () => {
    setShowRecordPayment(!showRecordPayment);
  };
  const addRiders = () => {
    setShowAddRiders(!showAddRiders);
  };
  const addManagers = () => {
    setShowAddManagers(!showAddManagers);
  };
  return (
    <div>
      <div className='border-t border-gray-border text-xs p-4 flex justify-between items-center mt-4'>
        <p>Last payout:{partner.last_payout}</p>
        <PartnersCardOptions
          editPartnerDetails={editPartnerDetails}
          deletePartner={deletePartner}
          recordPayment={recordPayment}
          addRiders={addRiders}
          addManagers={addManagers}
        />
      </div>
      <EditPartnerDetails
        show={showEditPartnerModal}
        closeModal={editPartnerDetails}
        partner={partner}
      />
      <DeletePartnerModal
        show={showDeletePartner}
        onConfirm={deletePartner}
        onClose={closeDeletePartner}
        partner={partner}
        handleDeletePartner={handleDeletePartner}
      />
      {showAddManagers && <AddMananagersModal onClose={addManagers} partner={partner} />}
      {showAddRiders && <AddRidersModal onClose={addRiders} partner={partner} />}
      {showRecordPayment && <RecordPayment partner={partner} onClose={recordPayment} />}
    </div>
  );
};

export default PartnersCardFooter;
